import { Box, Flex } from "@chakra-ui/react";
import { DateTime } from "luxon";
import React from "react";
import CustomSelect from "../../../components/Common/CustomInput/CustomSelect";
import DateRangeInputs from "./DateRangeInputs";
import { OrderStatusType } from "./types";

interface Props {
  startDate?: DateTime | null;
  endDate?: DateTime | null;
  handleStartDate?: (date: DateTime | null) => void;
  handleEndDate?: (date: DateTime | null) => void;
  onSearchDate?: () => void;
  onClear?: () => void;
  isLoading?: boolean;
  statusValue?: OrderStatusType;
  handleStatusChange?: (evt: React.ChangeEvent<HTMLInputElement>) => void;
  StatusData?: any;
}

const Filter: React.FC<Props> = ({
  startDate,
  endDate,
  onSearchDate,
  onClear,
  isLoading = false,
  handleEndDate,
  handleStartDate,
  StatusData,
  handleStatusChange,
  statusValue,
}) => {

  return (
    <React.Fragment>
      <Box display="flex" flexDirection="column" >
        <Flex gap={3}>
          <CustomSelect
            name={"status"}
            value={statusValue}
            handleChange={handleStatusChange}
            data={StatusData}
            width="max-content"
          />
          <DateRangeInputs
            startDate={startDate ?? null}
            endDate={endDate ?? null}
            handleStartDate={handleStartDate ?? (() => {})}
            handleEndDate={handleEndDate ?? (() => {})}
            onSearch={onSearchDate ?? (() => {})}
            onClear={onClear ?? (() => {})}
            isLoading={isLoading}
          />
        </Flex>
      
      </Box>
    </React.Fragment>
  );
};

export default Filter;
